import { Injectable } from "@angular/core";
import { IApplicationOptions } from "@pixi/app";
import { PixiApplicationFactory } from "@karma-games/angular-devkit/src/lib/modules/pixi";
import { CrocoGameApp } from "./croco-game-app";
import { CrocoScreenGlowGameApp } from "./croco-screen-glow-app";
import { ECrocoGameApp } from "./enums";

@Injectable()
export class CrocoGameAppFactory extends PixiApplicationFactory {
    override createApp(options?: IApplicationOptions, type: ECrocoGameApp = ECrocoGameApp.CrocoGameApp): CrocoGameApp | CrocoScreenGlowGameApp {
        switch (type) {
            case ECrocoGameApp.CrocoGameApp:
                return new CrocoGameApp(this.pixiLoader, options);
            case ECrocoGameApp.CrocoScreenGlowGameApp:
                return new CrocoScreenGlowGameApp(this.pixiLoader, options);
            default:
                return new CrocoGameApp(this.pixiLoader, options);
        }
    }
}
